import React from 'react';
import { Typography } from '@mui/material';
import rpcShared from '@rockpapercoin/rpc-shared';

import {
	UserForContractSentEventFeed,
	userIsActingUserOnEvent,
	userIsAssignedMemberOrVendorAdminOnContractEvent,
	userIsCustomerOnContractEvent,
	userIsAPPAOnContractEvent,
	getCustomerLinksAsVendorOrAPPAForContractEvent,
	DefaultEventProps,
} from './helpers';
// Lib
import { getDetailLink, linkObject } from '../../../lib/helpers';
import { LinkObjectType } from '../../../lib/helpers/types';

const getContractResentEventProps = (
	defaultEventProps: DefaultEventProps,
	user: UserForContractSentEventFeed
) => {
	if (
		!defaultEventProps.event.contract ||
		typeof defaultEventProps.event.contract === 'undefined'
	) {
		throw new Error( 'No contract provided' );
	}
	const { event } = defaultEventProps;
	defaultEventProps.icon = 'contract';
	if (
		userIsAPPAOnContractEvent( event, user ) &&
		!userIsAssignedMemberOrVendorAdminOnContractEvent( event, user )
	) {
		// you are the planner viewing the event where one or more of your customers
		// is a signer on this contract
		// but you are NOT also the vendor on the contract
		// meaning you are acting in a planner capacity
		const signaturesPlannerCanSign =
			rpcShared.contracts.getSignableSignaturesForCustomerAsAPPA(
				defaultEventProps.event.contract,
				user
			);
		const hasSigningPermission = !!signaturesPlannerCanSign?.length;

		defaultEventProps.message = (
			<Typography>
				{ linkObject( defaultEventProps.event.contract ) } has been resent by{ ' ' }
				{ linkObject( event.vendor ) }.
			</Typography>
		);
		defaultEventProps.links = [
			{
				type:
					event.resolvedAt || !hasSigningPermission ? 'secondary' : 'primary',
				text: event.resolvedAt || !hasSigningPermission ? 'View' : 'Sign',
				link: getDetailLink( {
					object: defaultEventProps.event.contract,
					type: LinkObjectType.Contract,
				} ),
			},
		];
	} else if (
		userIsActingUserOnEvent( event, user ) ||
		userIsAssignedMemberOrVendorAdminOnContractEvent( event, user )
	) {
		// you are the person who sent the document
		// you are the assigned member to one of the customers on the contract
		// you are an admin of the vendor org
		defaultEventProps.message = (
			<Typography>
				You resent { linkObject( defaultEventProps.event.contract ) } to{ ' ' }
				{ getCustomerLinksAsVendorOrAPPAForContractEvent( event, user, false ) }.
			</Typography>
		);
		defaultEventProps.links = [
			{
				type: 'secondary',
				text: 'View',
				link: getDetailLink( {
					object: defaultEventProps.event.contract,
					type: LinkObjectType.Contract,
				} ),
			},
		];
	} else if ( userIsCustomerOnContractEvent( event, user ) ) {
		// you are a customer
		defaultEventProps.message = (
			<Typography>
				{ linkObject( defaultEventProps.event.contract ) } has been resent by{ ' ' }
				{ linkObject( event.vendor ) }.
			</Typography>
		);
		defaultEventProps.links = [
			{
				type: event.resolvedAt ? 'secondary' : 'primary',
				text: event.resolvedAt ? 'View' : 'Sign',
				link: getDetailLink( {
					object: defaultEventProps.event.contract,
					type: LinkObjectType.Contract,
				} ),
				className: 'eventRow-contract-resent__sign-btn',
			},
		];
	} else {
		//eslint-disable-next-line max-len
		throw new Error(
			`getContractResentEventProps unable to determine user role.\n event:\n ${ JSON.stringify(
				event,
				null,
				2
			) }\n user: \n ${ user } `
		);
	}
	return defaultEventProps;
};

export default getContractResentEventProps;
